import styled from 'styled-components'

export const SFContainer = styled.div`
  padding: 24px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const Field = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`

export const Label = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin-right: 16px;
  min-width: 150px;
`

export const Value = styled.p`
  font-size: 16px;
`

export const Image = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 16px;
`
